<template>
  <v-app>
    <v-container>
      <v-row>
        <v-col cols="12">
          <ordered-select v-model="items" collection="benchmarksCollection" name="sorting"></ordered-select>
          <unit-dropdown v-model="item" :refs="gender"></unit-dropdown>
          <unit-range v-model="num" :min="0" :max="10" label="Proficiencey"></unit-range>
          <pre>
            {{item}}
          </pre>
           <pre>
            {{num}}
          </pre>
        </v-col>
      </v-row>      
    </v-container>
    <pre>
      {{items}}
    </pre>
  </v-app>
</template>

<script>
// @ is an alias to /src
import{ OrderedSelect } from "@/components/core"
import{ UnitDropdown, UnitRange } from "@/components/units"
export default {
  name: "AdminTest",
  components: {
    OrderedSelect,
    UnitDropdown,
    UnitRange
  },
  data() {
    return {
      num:0,
      gender: [
        'male', 'female'
      ],
      items: [
  {
    "index": 0,
    "title": "Alserkal Avenue",
    "id": "J5i8NX53kSChE5UJTlMf"
  },
  {
    "index": 1,
    "title": "Sharjah Art Foundation",
    "id": "9g3KW14K4fO8UtZ2zi43"
  },
  {
    "index": 2,
    "title": "Hand in Hand (Future)",
    "id": "FO9UVrVBXBFkzH2fSWmX"
  },
  {
    "index": 3,
    "title": "Hand in Hand (Now)",
    "id": "5PTl8ln7KIwzgGP6NpmX"
  }
],
item : null
    }
  }
};
</script>